module.exports = __webpack_public_path__ + "img/aidtools_s3.c772e72f.png";